function initSizeGuide() {
  "use strict";

  const $all = (el, sel) => Array.from(el.querySelectorAll(sel));
  const attr = (el, name, def = "") => (el?.getAttribute(name) || def).trim();

  document.querySelectorAll("[data-size-guide-root]").forEach((root) => {
    const modal = root.querySelector("[data-size-guide-modal]");
    const openBtns = $all(root, "[data-size-guide-open]");
    const closeEls = $all(root, "[data-size-guide-close]");
    const tabs = $all(root, "[data-size-guide-tab]");
    const panels = $all(root, "[data-size-guide-panel]");
    const chartHolder = root.querySelector("[data-size-guide-chart]");
    const chartUrl = attr(root, "data-size-guide-chart-url");

    if (modal) {
      const inForm = !!modal.closest("form") || !!root.closest("form");
      if (inForm) document.body.appendChild(modal);
    }

    const openModal = (ev) => {
      ev?.preventDefault?.(); ev?.stopPropagation?.();
      if (!modal) {
        return;
      }
      modal.setAttribute("data-size-guide-opened", "true");
      modal.setAttribute("aria-hidden", "false");
    };

    const closeModal = (ev) => {
      ev?.preventDefault?.(); ev?.stopPropagation?.();
      if (!modal) {
        return;
      }
      modal.removeAttribute("data-size-guide-opened");
      modal.setAttribute("aria-hidden", "true");
    };

    openBtns.forEach((btn) => btn.addEventListener("click", openModal));
    closeEls.forEach((el) => el.addEventListener("click", closeModal));
    if (modal) modal.addEventListener("click", (e) => { if (e.target === modal) closeModal(e); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeModal(e); });

    function activateTab(id) {
      tabs.forEach((t) => {
        const active = attr(t, "data-size-guide-tab") === id;
        t.setAttribute("data-size-guide-active", active ? "true" : "false");
        t.setAttribute("aria-selected", active ? "true" : "false");
      });
      panels.forEach((p) => {
        const active = attr(p, "data-size-guide-panel") === id;
        p.setAttribute("data-size-guide-active", active ? "true" : "false");
      });
      if (id === "chart") ensureChart();
    }
    
    tabs.forEach((t) => t.addEventListener("click", (e) => {
      e.preventDefault(); e.stopPropagation();
      activateTab(attr(t, "data-size-guide-tab"));
    }));
    if (!tabs.some((t) => attr(t, "data-size-guide-active") === "true")) activateTab("quick");

    let chartLoaded = false;
    function ensureChart() {
      if (chartLoaded || !chartHolder) return;
      chartLoaded = true;
      const inlineNode = root.querySelector("[data-size-guide-chart-inline]");
      const inlineText = inlineNode ? inlineNode.textContent.trim() : "";
      if (inlineText) {
        const data = parseDelimited(inlineText);
        chartHolder.innerHTML = renderTable(data);
        return;
      }
      if (!chartUrl) {
        chartHolder.innerHTML = '<p class="size-guide__muted">Chart coming soon.</p>';
        return;
      }

      fetch(chartUrl, { cache: "no-store" })
        .then((r) => r.text())
        .then((text) => {
          const data = parseDelimited(text);
          chartHolder.innerHTML = renderTable(data);
        })
        .catch(() => {
          chartHolder.innerHTML = '<p class="size-guide__muted">Unable to load chart.</p>';
        });
    }

    function parseDelimited(text) {
      const norm = text.replace(/\r\n?/g, "\n");
      const first = (norm.split("\n").find((l) => l.trim().length) || "");
      const delim = ((first.match(/\t/g) || []).length > (first.match(/,/g) || []).length) ? "\t" : ",";
      return parseCSVLike(norm, delim);
    }

    function parseCSVLike(text, delim) {
      const rows = [];
      let row = [], cell = "", inQuotes = false;
      for (let i = 0; i < text.length; i++) {
        const c = text[i], n = text[i + 1];
        if (inQuotes) {
          if (c === '"' && n === '"') { cell += '"'; i++; continue; }
          if (c === '"') { inQuotes = false; continue; }
          cell += c;
        } else {
          if (c === '"') { inQuotes = true; continue; }
          if (c === delim) { row.push(cell.trim()); cell = ""; continue; }
          if (c === "\n" || c === "\r") {
            if (cell.length || row.length) { row.push(cell.trim()); rows.push(row); row = []; cell = ""; }
            continue;
          }
          cell += c;
        }
      }
      if (cell.length || row.length) { row.push(cell.trim()); rows.push(row); }
      return rows.filter((r) => r.length && r.some((v) => v !== ""));
    }

    function escapeHTML(s) {
      return String(s).replace(/[&<>"']/g, (m) => ({
        "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
      })[m]);
    }

    function renderTable(data) {
      if (!data.length) return '<p class="size-guide__muted">No data in chart.</p>';
      const cols = data.reduce((m, r) => Math.max(m, r.length), 0);
      let html = '<table class="size-guide__chart-table"><tbody class="size-guide__chart__tbody">';
      data.forEach((row) => {
        html += '<tr class="size-guide__chart__tr">';
        for (let i = 0; i < cols; i++) {
          html += `<td class="size-guide__chart__td">${escapeHTML(row[i] || "")}</td>`;
        }
        html += '</tr>';
      });
      html += '</tbody></table>';
      return html;
    }
  });

  document.querySelectorAll("[data-size-guide-faq]").forEach((faqRoot) => {
    const single = faqRoot.getAttribute("data-accordion") === "single";
    faqRoot.querySelectorAll("[data-faq-toggle]").forEach((btn) => {
      const item = btn.closest("[data-faq-item]");
      const answerId = btn.getAttribute("aria-controls");
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const willOpen = item.getAttribute("data-open") !== "true";
        if (single && willOpen) {
          faqRoot.querySelectorAll("[data-faq-item][data-open='true']").forEach((openItem) => {
            openItem.removeAttribute("data-open");
            const b = openItem.querySelector("[data-faq-toggle]");
            if (b) b.setAttribute("aria-expanded", "false");
          });
        }
        if (willOpen) {
          item.setAttribute("data-open", "true");
          btn.setAttribute("aria-expanded", "true");
        } else {
          item.removeAttribute("data-open");
          btn.setAttribute("aria-expanded", "false");
        }
        if (answerId) {
          const ans = document.getElementById(answerId);
          if (ans) ans.setAttribute("aria-hidden", willOpen ? "false" : "true");
        }
      });
    });
  });
}
initSizeGuide();
